import React, { createRef, useCallback, useEffect, useRef, useState } from 'react';
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
  DirectionsRenderer,
  DirectionsService,
  Autocomplete,
  StandaloneSearchBox,
} from '@react-google-maps/api';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { MdClose } from "react-icons/md";

import _ from 'lodash';
import { IoMdArrowDropdown } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { selectCurrent } from '../../redux/settings/selectors';
interface UserMapData {
  lat: number;
  lng: number;
}



const GoogleSearchMap = ({ label, setLocation, location, placeholder }: any) => {
  const [color, setColor] = useState('universal')
  const result = useSelector(selectCurrent)
  const [error, setError] = useState('');
  const { header, footer, visible, sidebar, theme, primary, secondary } = result

  useEffect(() => {
    setColor(theme)



  }, [theme]);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDOCJ7V-QaS9nnf7zZ1B7ZEgrkI-YcxWA0",
    libraries: ["places"],
  });

  const autocompleteRef: any = useRef();

  const onLoadAutocomplete = (autocomplete: any) => {
    autocompleteRef.current = autocomplete
  }
  const handlePlaceChanged = () => {
    const geometry = autocompleteRef.current.getPlace();


    const pincodeData: any = _.last(geometry?.address_components)
    if (geometry?.geometry) {
      setLocation({
        name: geometry?.name,
        lat: geometry.geometry.location.lat(),
        long: geometry.geometry.location.lng(),
        pincode: pincodeData?.long_name,
        description: geometry?.formatted_address
      });
      setError('');
    }

  };

  const handleBlur = () => {
    if (!location.lat || !location.long) {
      setError('Please select a valid location.');
    } else {
      setError('');
    }
  };

  const handleChanged = (event: any) => {
    const searched_location = event.target.value;
    setLocation({
      ...location,
      name: searched_location,
    });
    setError('');
  }
  function clearSearch() {

    if (autocompleteRef.current) {

      setLocation({
        name: "",
        lat: "",
        lng: "",
        pincode: ""
      });
      setError('');
    }

  }

  return isLoaded ? (
    <>


      <div
        className={`d-flex align-items-center`}
      >

        <div className="relative">
          <div className="flex absolute inset-y-0 left-0 items-center pl-2 pointer-events-none">
            <FaMapMarkerAlt className="skin-base opacity-60" />
          </div>

          <Autocomplete
            onLoad={onLoadAutocomplete}
            onPlaceChanged={handlePlaceChanged}

            options={{
              fields:
                ["address_components",
                  "geometry", "name", "adr_address", "business_status", "formatted_address", "place_id", "type", "icon", "icon_mask_base_uri", "icon_background_color", "photo"],
            }}
          >
            <input required type="text" placeholder={placeholder} onBlur={handleBlur} onChange={(event) => handleChanged(event)} ref={autocompleteRef} value={location?.description || location?.name}

              className={`w-full border-b-2 border-black ps-8  pe-10 py-1`} />

          </Autocomplete>
          {location?.name ? (
            <button
              type="button"
              onClick={clearSearch}
              title="Clear search"
              className="outline-none absolute top-0 end-0 w-14 md:w-16 h-full flex items-center justify-center transition duration-200 ease-in-out hover:text-heading focus:outline-none"
            >
              <MdClose className="w-[17px] h-[17px] text-skin-base text-opacity-40" />
            </button>
          ) : (
            <span className="w-14 md:w-16 h-full absolute top-0 end-0 flex flex-shrink-0 justify-center items-center focus:outline-none">
              <IoMdArrowDropdown width="13" height="8" />
            </span>
          )}

        </div>
        {error && <div className="text-red-600 text-sm p-2">{error}</div>}
      </div>




    </>
  ) : (
    <div>Loading....</div>
  );
};

export default React.memo(GoogleSearchMap);
